<script setup lang="ts">

import { States } from "@domain/General";
import { Field, makeForm } from "@library/Components/Forms/Form";
import { useWelcomeFlowStore } from "../WelcomeFlowStore";
import { storeToRefs } from "pinia";

const welcomeFlowStore = useWelcomeFlowStore();
const vehicle = storeToRefs( welcomeFlowStore ).vehicle;

const form = makeForm( vehicle );

// The validation rules
const validation = {
    rego: [
        Field.required( "Please enter your vehicle's registration number", 2, 9 ),
        Field.regoNumber( "Please ensure the registration number is valid." )
    ],
    regoState: [
        Field.required( "Please select the state your vehicle is registered in", 2 ),
    ],
    odometer: [
        Field.required( "Please enter your odometer", 0, 999999999 ),
        Field.numbersOnly( "Please enter a valid odometer value" )
    ]
};

</script>

<template>

    <Form class="flex flex-col gap-y-2 w-full items-center"
          :form="form"
          v-slot="{form}">

        <form class="w-full">

            <!-- REGISTRATION NUMBER -->
            <div v-if="welcomeFlowStore.hasSearchedForVehicle == false" 
                 class="px-4 2xl:px-8 mb-4">

                <div class="mb-3 2xl:mb-4 rounded">

                    <div class="py-1 3xl:py-2 px-2 3xl:px-4 bg-white/[7%] rounded">
                        <TextField label="Enter your rego"
                                placeholder="Enter your rego"
                                v-model="welcomeFlowStore.vehicle.rego"
                                bg-color="transparent"
                                variant="solo"
                                required
                                :rules="validation.rego"
                                hide-details="auto"
                                minlength="2"
                                maxlength="9"
                                flat
                                @input="() => { welcomeFlowStore.vehicle.rego = ( welcomeFlowStore.vehicle.rego ?? '' ).toUpperCase(); }"
                        />
                    </div>

                </div>

                <SelectList 
                    label="Vehicle Registration State"
                    placeholder="Select registration state"
                    v-model="welcomeFlowStore.vehicle.regoState"
                    :rules="validation.regoState"
                    required
                    hide-details="auto"
                    :items="States.toListItems()" 
                />            
            
            </div>

            <!-- ODOMETER - NOT SHOWN UNTIL SEARCH HAS BEEN PERFORMED -->
            <div v-show="welcomeFlowStore.hasSearchedForVehicle"
                 class="px-4 2xl:px-8 flex flex-col gap-2 lg:gap-4 3xl:gap-6">

                <div class="text-base text-center">
                    <div>Let's finish setting it up</div>
                    <div class="opacity-60 font-semibold -top-1">Please enter your odometer</div>
                </div>

                <TextField 
                    v-model="welcomeFlowStore.vehicle.odometer"
                    label="Current odometer"
                    :min="0"
                    :max="20000000"
                    :rules="validation.odometer"
                    required
                    hide-details="auto">
                    <template #append-inner>
                        <span class="opacity-50">km</span>
                    </template>
                </TextField>

            </div>

        </form>

        <!-- ACTION BUTTONS INJECTED HERE -->
        <slot name="actions" :form="form"></slot>

    </Form>

</template>
